import { render, staticRenderFns } from "./classical-mentoring.vue?vue&type=template&id=ce5255e8"
import script from "./classical-mentoring.vue?vue&type=script&lang=js"
export * from "./classical-mentoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports